export default { 
    paymentType: {}
}